export const EMfaMethod = {
  EMAIL: "email",
  SMS: "sms",
} as const;

export type EMfaMethod = (typeof EMfaMethod)[keyof typeof EMfaMethod];
